import styled, { css } from 'styled-components';

export const BlockedRegionMessage = styled.div`
  ${({ theme: { spacing, borderRadius, color } }) => css`
    padding: ${spacing.lg};
    background-color: ${color.red10};
    border-radius: ${borderRadius.sm};
  `}
`;
